import { render, staticRenderFns } from "./LeadsDetails.vue?vue&type=template&id=026c79bd&"
import script from "./LeadsDetails.vue?vue&type=script&lang=js&"
export * from "./LeadsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports